<template>
  <div
    :id="this.id"
    @contextmenu.prevent="handler($event)"
    class="sitebuilder-element-container"
    element="ImageGalleryComponent"
    :data-hide-desktop="!this.internal_config.showDesktop"
    :data-hide-mobile="!this.internal_config.showMobile"
    :config-properties="JSON.stringify(internal_config)"
    :style="style()"
    v-on:click="focusElement($event)"
  >
    <vue-draggable-resizable
      v-bind:w="parseInt(internal_config.width)"
      v-bind:h="parseInt(internal_config.height)"
      @resizing="onResize" ref="draggableResizable"
      :draggable="false"
    >
      <rotate :target="this.$refs.draggableResizable" :config="this.internal_config" />

      <sync-drag :target="this" />

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-ImageGalleryComponent'>
        <img src="static/images/icons/engrenagem.svg"
             class="svg-icon normal-action"
             @click="openPopupChoose"/>
      </options-element-bar>
      <div ref="image-gallery" class="image-gallery-container"
           :class="{
              'paginate-with-min': (parseInt(internal_config.height) <= 300 && internal_config.allImages.length > parseInt(internal_config.imagesPerPage)),
              'paginate-with-max': (parseInt(internal_config.height) > 500 && internal_config.allImages.length > parseInt(internal_config.imagesPerPage)),
              'without-paginate': internal_config.allImages.length <= parseInt(internal_config.imagesPerPage)}"
           :style="{minHeight : minHeight}">

        <matriz-gallery v-if="internal_config.theme === 'matriz'" :internal_config="internal_config" @showPhoto="showPhoto"/>
        <alternating-gallery v-else-if="internal_config.theme === 'alternating'" :internal_config="internal_config" @showPhoto="showPhoto"/>
        <tiles-gallery v-else-if="internal_config.theme === 'tiles'" :internal_config="internal_config" @showPhoto="showPhoto"/>
        <mixed-gallery v-else-if="internal_config.theme === 'mixed'" :internal_config="internal_config" @showPhoto="showPhoto"/>
        <one-main v-else-if="internal_config.theme === 'one-main'" :internal_config="internal_config" @showPhoto="showPhoto"/>

        <!-- PAGINATE -->
        <div class="paginate" v-if="internal_config.allImages.length > parseInt(internal_config.imagesPerPage)">
          <div v-if="internal_config.navigationWithNumber">
            <a
              v-for="(page, index) in internal_config.lastPage"
              :key="index"
              class="number"
              :class="{ active: (internal_config.currentPage+1) == page }"
              :style="styleNavigation()"
              @click="paginate(page-1)"
            >{{ page }}</a>
          </div>
          <div v-else>
            <a
              v-for="(page, index) in internal_config.lastPage"
              :key="index"
              class="circle"
              :class="{ active: (internal_config.currentPage+1) == page }"
              :style="styleNavigation()"
              @click="paginate(page-1)"
            ></a>
          </div>
        </div>
      </div>

      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>

    <!-- SHOW IMAGE -->
    <div
      class="image-gallery-overlay"
      v-show="internal_config.isShowImage"
      @click="internal_config.isShowImage=false"
    ></div>
    <div
      class="image-gallery-show"
      v-show="internal_config.isShowImage"
      @click="internal_config.isShowImage=false"
    >
      <img :src="internal_config.showImageUrl" alt/>
    </div>
  </div>
</template>

<script>
import ImageGalleryData from './Model';
import Resources from './Resources.vue';
import OptionsElementBar from '../OptionsElementBar';
import MatrizGallery from "./themes/MatrizGallery";
import AlternatingGallery from "./themes/AlternatingGallery";
import TilesGallery from "./themes/TilesGallery";
import MixedGallery from "./themes/MixedGallery";
import OneMain from "./themes/OneMainGallery";

export default {
  name: 'ImageGalleryComponent',
  props: ['config', 'id', 'preview'],
  components: {
    OneMain,
    MixedGallery,
    TilesGallery,
    AlternatingGallery,
    MatrizGallery,
    OptionsElementBar,
    Resources
  },
  computed: {
    minHeight() {
      return this.internal_config.minHeight;
    },
    opacity() {
      return this.internal_config.opacity;
    },
    border() {
      return this.internal_config.border;
    },
    boxShadow() {
      return this.internal_config.boxShadow;
    },
    radius() {
      return this.internal_config.borderRadius;
    }
  },
  data() {
    return ImageGalleryData.data();
  },
  watch: {
    'internal_config.imagesPerPage': function(newValue) {
      this.build();
    },
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    }
  },
  methods: {
    openPopupChoose() {
      this.$root.$emit('openImageGalleryModal', this.internal_config, 'modalChooseImage', this.saveAll);
    },
    saveAll(config) {
      this.internal_config = Object.assign({}, this.internal_config, config);
      this.build();
    },
    paginate(page) {
      const {images, allImages, imagesPerPage} = this.internal_config;

      const lastPhoto = allImages.length;

      this.internal_config.currentPage = page;

      const idStart = Math.floor(page * imagesPerPage);
      const idEnd =
          parseInt(idStart) + parseInt(imagesPerPage) > lastPhoto
            ? lastPhoto
            : parseInt(idStart) + parseInt(imagesPerPage);

        // drop the visible photos
      images.splice(0, images.length);

      // reload visible photos from all photo
      for (let index = idStart; index < idEnd; index++) {
        images.push(allImages[index]);
      }
    },
    showPhoto(index) {
      if (!this.$props.preview) return false;

      this.internal_config.isShowImage = true;
      this.internal_config.showImageUrl = this.internal_config.allImages[index];
      this.internal_config.currentImage = index;
      window.scrollTo(0, 0);
    },
    build() {
      const {allImages, imagesPerPage} = this.internal_config;
      this.internal_config.lastPage = Math.ceil(
        allImages.length / imagesPerPage
      );

      this.paginate(0);
    },
    animation() {
      return true;
    },

    onResize(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },

    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },
    styleNavigation() {
      const {navigationBackground, navigationHover, navigationActive} = this.internal_config;
      return `--background-color: ${navigationBackground};
              --background-color--hover: ${navigationHover};
              --background-color-active: ${navigationActive};`;
    },
    style() {
      var style = `width: ${this.internal_config.width};
                     height:  ${this.internal_config.height};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     left:  ${this.internal_config.left};
                     top: ${this.internal_config.top}`;
      return style;
    },
    styleResize() {
      return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
    },
    handler(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    hover() {
      this.$emit('highlightHover', {
        name: this.name,
        posicao: this.$refs.image.getBoundingClientRect()
      });
    }
  },
  created() {
    this.internal_config = window.mergeRecursive(
      this.props,
      this.$props.config
    );
  },
  mounted() {
    if (this.$props.preview) {
      this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
    }

    this.$root.$on('setConfigElement', (id, obj) => {
      if (this.id == id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });

    this.$refs.resourcesData.setValuesData(this);

    this.build();
  }
};
</script>
<style lang="scss" scoped>
  /** GALLERY */

  .image-gallery-container {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 85% 15%;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;

    &.paginate-with-max{
      grid-template-rows: calc(100% - 75px) 75px;
    }

    &.paginate-with-min{
      grid-template-rows: calc(100% - 35px) 35px;
    }

    &.without-paginate{
      grid-template-rows: 100%;
    }
  }

  [data-device="tablet"] .image-gallery-container,
  [data-device="mobile"] .image-gallery-container{
    grid-template-rows: calc(100% - 40px) 40px;
  }

  .image-gallery-photos-container {
    display: grid;
    width: 100%;
    height: 100%;
  }

  .image-gallery-photo {
    overflow: hidden;
    float: left;
    background-position: top center;
    background-size: cover;
    position: relative;
  }

  /** PAGINATE */

  .paginate,
  .paginate > div {
    display: grid;
    grid-gap: 10px;
    grid-auto-flow: column;
    align-items: center;
    justify-content: center;
    z-index: 99;

    & a {
      background: var(--background-color);
      border-radius: 50%;
      cursor: pointer;

      &.number {
        text-align: center;
        font-weight: "bold";
        width: 30px;
        border: 2px solid #222;
      }

      &.circle {
        //border: 1px solid #222;
        width: 15px;
        height: 15px;
      }

      &.active {
        background: var(--background-color-active);
      }

      &:hover {
        background: var(--background-color--hover);
      }
    }
  }

  /** SHOW IMAGE */

  .image-gallery-overlay {
    position: fixed;
    z-index: 10;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    text-align: center;
    background: rgba(37, 37, 37, 0.9);
    text-align: center;
  }

  .image-gallery-show {
    z-index: 9999;
    position: fixed;
    display: flex;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    margin-top: 100px;
    text-align: center;

    div {
      position: absolute;
      display: flex;
      justify-content: flex-end;
      max-width: 1260px;
      width: 100%;
      top: 0;
    }

    img {
      max-width: 1260px;
      width: 100%;
      border: 1px solid #aaa;
      box-shadow: 0 0 10px black;
    }
  }

  /**  MODAL CHOOSE IMAGE */

  .modal-choose-image {
    display: flex;
    flex-direction: column;

    :nth-child(4) {
      text-align: right;
    }
  }

  .modal-choose-image-container {
    display: grid;
    grid-template-columns: repeat(4, auto);
    grid-row-gap: 10px;
    grid-column-gap: 10px;
    margin: 20px 0 20px 0;
  }

  .modal-choose-box {
    position: relative;
    background-color: rgba(29, 64, 89, 0.8);
    border-radius: 10px;

    .modal-choose-box-image {
      width: 100%;
      height: 150px;
      border-radius: 10px;
      opacity: 1;
      display: block;
      transition: 0.5s ease;
      backface-visibility: hidden;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }

    &:hover .modal-choose-box-image {
      opacity: 0.3;
    }

    .modal-choose-image-options {
      transition: 0.5s ease;
      opacity: 0;
      position: absolute;
      width: 34px;
      height: 34px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      text-align: center;

      span {
        width: 100%;
        height: 100%;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &:hover {
          background-color: gray;
        }
      }
    }

    &:hover .modal-choose-image-options {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/ImageGallery/ImageGallery.vue